<style scoped lang="scss">
  .wrap-primer{
    .top{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title{
      h3{
        font-size: 24px;
        font-weight: bold;
      }
    }
    .el-steps{
      width:350px;
    }
    .up-down{
      padding:15px 30px;
      background: #F9F9F9;
      margin-top: 30px;
      .upload{
        position: relative;
        input{
          position: absolute;
          z-index: 3;
          left:0;
          width:100px;
          opacity: 0;
          cursor: pointer;
        }
      }
    }
    .table-top{
      display: flex;
      justify-content: space-between;
      margin:20px 0 0;
    }
  }
  .intro{
    color:#999;
    display: flex;
    margin-bottom: 20px;
    span{
      display: flex;
      align-items: center;
      margin-left: 20px;
      img{
        margin-left: 10px;
        width:16px;
      }
    }
  }
  th{
    img{
      display: block;
      margin: 5px auto 0;
      cursor: pointer;
    }
  }
  .copy{
    cursor: pointer;
    span{
      width: 18px;
    }
  }
  .table-con{
    position: relative;
    .mask{
      position: absolute;
      left:0;
      top:0;
      background: rgba(0,0,0,.2);
      width:100%;
      height:100%;
      z-index: 99;
      text-align: center;
      color:#999;
      .icon{
        margin-top: 200px;
        font-size: 40px;
      }
    }
  }
  .col-header{
    img{
      width:16px;
    }
  }
  .tooltip{
    position: absolute;
    z-index: 0;
    background: #fff;
    border:1px solid #eee;
    padding:10px;
    width:300px;
    left:191px;
    display: none;
    box-shadow: 0 2px 3px rgba(0,0,0,.2);
  }
  .sample-table{
    position: relative;
  }
</style>
<style lang="scss">
  .wrap-primer{
    .table{
      .el-input__inner{
        border:0;
        width:100px;
      }
    }
  }
  .purifying-popover{
     display: inline-block;
     &>span{
        padding: 0 !important;
        cursor: pointer;
     }
     .el-icon-warning-outline{
      color: #e6a23c;
     }
     .el-popover__reference-wrapper{
      padding: 0 !important;
     }
  }
</style>
<template>
  <div class="wrap wrap-primer" v-loading="submitLoading">
    <section class="container">
      <div class="top">
        <div class="title">
          <h3>引物合成在线订购</h3>
          <p class="pointer" v-show="unCompleteOrders > 0" @click="toOrders">未处理订单（<span class="text-primary">{{unCompleteOrders}}</span>）</p>
        </div>
        <el-steps :active="0" finish-status="success" align-center>
          <el-step title="录入引物基础信息"></el-step>
          <el-step title="确认订单"></el-step>
        </el-steps>
      </div>
      <div class="up-down">
        <a href="https://tsingke-oss.oss-cn-beijing.aliyuncs.com/official-web/%E6%93%8E%E7%A7%91%E7%94%9F%E7%89%A9%E5%BC%95%E7%89%A9%E5%90%88%E6%88%90%E8%AE%A2%E8%B4%AD%E8%A1%A8.xlsx" download="引物合成在线订购模板" class="text-primary mr30"><span class="el-icon-download"> 模版下载</span></a>
        <span class="text-primary mr30 upload">
          <span class="el-icon-upload2"> 引物信息上传</span>
          <input type="file" @change="uploadFiles" @click="uploading = true"/>
        </span>
        <span class="text-gray9">下载并填写模版，上传后文件内的信息会自动匹配至下方列表</span>
      </div>
      <div class="table-top">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="引物条数：">
            <el-input v-model.number="primerNum" type="number" @input="inputPrimerNum"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleUsePrimers">应用</el-button>
          </el-form-item>
        </el-form>
        <div class="btn-group">
          <el-button type="primary" @click="addRow">增加一行</el-button>
          <el-button @click="clearTable">清空表格</el-button>
          <el-button @click="deleteSelect">批量删除</el-button>
        </div>
      </div>
      <div class="intro">
        说明：可将信息从Excel表中复制粘贴至当前表格中，
        <span>点击按钮 <img src="@/assets/images/icon_copy2.png"> </span>
        <span>按顺序递增编号</span>
        <span>点击按钮 <img src="@/assets/images/icon_down3.png"></span>
        <span>按第一行内容向下填充</span>
        <span class="text-danger mr10">*</span>为必填内容
      </div>
      <div
        class="sample-table"
        v-loading="loading"
        element-loading-text="数据导入中..."
      >
        <div class="col-header">
          <span :style="{ width: hotSettings.colWidths[0],'line-height':'37px' }">
            <input type="checkbox" @click="checkboxOnclick($event)"/>
          </span>
          <span :style="{ width: hotSettings.colWidths[1] }">序号</span>
          <span :style="{ width: hotSettings.colWidths[2] }">
					  引物名称
            <i style="color: red">*</i>
            <img src="@/assets/images/icon_copy2.png" @click="nameClick">
				  </span>
          <span :style="{ width: hotSettings.colWidths[3] }">
            引物序列
            <div class="purifying-popover">
              <el-popover
                placement="top-start"
                title="兼并碱基代码对应说明"
                width="280"
                trigger="hover"
                >
                <div>
                   <div>B=G/C/T　D=A/G/T　H=A/C/T　K=G/T　M=A/C　N=A/G/C/T　R=A/G　S=G/C　V=A/G/C　W=A/T　Y=C/T</div>
                </div>
                <b class="el-icon-warning-outline" slot="reference"></b>
              </el-popover>
            </div>
            <i style="color: red">*</i>
            <img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('sequence')">
          </span>
          <span :style="{ width: hotSettings.colWidths[4] }">碱基数</span>
          <span :style="{ width: hotSettings.colWidths[5] }">
					  纯化方式
            <div class="purifying-popover">
              <el-popover
                placement="top-start"
                title="纯化方式选项说明"
                width="280"
                trigger="hover"
                >
                <div>
                   <div>OPC：可满足大多分子生物学实验</div>
                   <div>HPLC：适合60nt以下修饰引物纯化</div>
                   <div>PAGE：适合长链引物纯化</div>
                </div>
                <b class="el-icon-warning-outline" slot="reference"></b>
              </el-popover>
            </div>
             <i style="color: red">*</i>
            <img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('purificationWay')">
				  </span>
          <span :style="{ width: hotSettings.colWidths[6] }">
					  OD/管
            <i style="color: red">*</i>
            <img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('odNum')">
				</span>
        <span :style="{ width: hotSettings.colWidths[7] }">
					分装管数
          <i style="color: red">*</i>
					<img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('fzNum')">
				</span>
          <span :style="{ width: hotSettings.colWidths[8] }">
					5端修饰
          <img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('modify5')">
				</span>
          <span :style="{ width: hotSettings.colWidths[9] }">
					3端修饰
            <img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('modify3')">
				</span>
          <span :style="{ width: hotSettings.colWidths[10] }">
					中间修饰
            <img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('modifyMid')">
				</span>
          <span :style="{ width: hotSettings.colWidths[11] }">
					备注
            <img src="@/assets/images/icon_down3.png" @click="handleSimpleClick('remark')">
				</span>
        </div>
        <hot-table ref="hotTable" :settings="hotSettings" class="hot-table" :licenseKey="licenseKey"></hot-table>
        <div class="table-none" v-show="hotSettings.data.length === 0">暂无数据</div>
        <div class="tooltip" id="tooltip"></div>
      </div>
      <div style="font-size: 16px;font-weight: 700;">客户备注</div>
      <el-input
        type="textarea"
        :rows="7"
        maxlength="100"
        placeholder="请输入备注信息"
        class="mt20"
        v-model="customerRemark"></el-input>
      <div class="tr mt30">
        <el-button type="primary" @click="bindConfirm" v-preventReClick>确认并提交订单，查看订单价格</el-button>
      </div>
    </section>
    <div class="popup-delete" v-if="toggleShow" @click="delRows" :style="{top: position.top + 'px'}">
      删除选中行
    </div>
  </div>
</template>

<script>
import { HotTable } from '@handsontable-pro/vue'
import 'handsontable-pro/dist/handsontable.full.css'
import { primerConfig, uploadPrimer, primerOrder, primerOrderEidt, primer, primerOrderDetail, primerInfo, primerPrice, getSystemDictByUnitType } from '@/services/api.index'
export default {
  components: {
    HotTable
  },
  data () {
    // 验证引物序列输入
    const validText = (val) => {
      let str = 'ATCGMRWSYKVHDBNIUatcgmrwsykvhdbniu*'
      if (!val || val === '') return
      let tempArr =
        val &&
        val.split('').map((k) => {
          return str.indexOf(k) > -1
        })

      return tempArr.some((v) => !v)
    }
    const _this = this
    return {
      loading: false,
      submitLoading: false,
      rows: 1,
      primerNum: 10,
      value1: '',
      decorate3: [],
      decorate5: [],
      decorateMid: [],
      purificationWays: ['OPC', 'PAGE', 'HPLC', 'WLYW'],
      primerSynthesesSet: [],
      tableData: [],
      customerRemark: '',
      toggleShow: false,
      uploading: false,
      position: {
        left: 0,
        top: 0
      },
      // defaultPurificationWay: this.baseMethods.getLocalObj('memberInfo').businessRequirement.primerPurificationType,
      multipleSelection: [],
      currentRow: {},
      editPrimerLists: [],
      licenseKey: '4d522-5237a-55f42-6653a-d1494',
      hotSettings: {
        data: [],
        // 定义表结构
        colHeaders: false, //自定义列表头or 布尔值
        fillHandle: 'vertical',
        columns: [
          { type: 'checkbox', data: 'checkbox' }, // data后面跟的这个字段是上传对应的字段
          {
            type: 'text',
            data: 'index',
            readOnly: true,
          },
          {
            data: 'name',
            // validator(val, callback) {
            //   // if (!val) return callback(false)
            //   let pattern = /^[A-Za-z0-9\u4e00-\u9fa5-_.]{0,50}$/
            //   if (pattern.test(val)) return callback(true)
            //   return callback(false)
            // }
          },
          {
            data: 'sequence',
            validator(val, callback,a,b,c) {
              // if (!val) return callback(false)
              val = val ? val.replace(/\s/g, '') : val;
              let bool = validText(val)
              if (!bool && val.length <= 300) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'dsDna',
            readOnly: true
          },
          {
            type: 'dropdown',
            data: 'purificationWay',
            source: ['OPC', 'PAGE', 'HPLC', 'WLYW'],
            strict: true
            // validator(val, callback) {
            //   if (!val) return callback(false)
            //   return callback(true)
            // }
          },
          {
            data: 'odNum',
            type: 'numeric',
            validator(val, callback) {
              if (val <= 1000 && val >= 0) return callback(true)
              return callback(false)
            }
          },
          {
            data: 'fzNum',
            type: 'numeric',
            validator(val, callback) {
              if (val <= 1000 && val >= 0) return callback(true)
              return callback(false)
            }
          },
          {
            type: 'dropdown',
            data: 'modify5',
            source: []
          },
          {
            type: 'dropdown',
            data: 'modify3',
            source: []
          },
          {
            type: 'dropdown',
            data: 'modifyMid',
            source: []
          },
          {
            data: 'remark',
            // validator(val, callback) {
            //   // if (!val) return callback(false)
            //   let pattern = /^[A-Za-z0-9\u4e00-\u9fa5-_.]{0,50}$/
            //   if (pattern.test(val)) return callback(true)
            //   return callback(false)
            // }
          },
        ],
        minRows: 0, // 最小行列
        minCols: 0,
        maxRows: 500, // maxRows: 500,
        height: 430,
        autoWrapRow: true, // 自动换行
        colWidths: ['4%', '4%', '7%', '25%', '5%', '7%', '6%', '7%', '9%', '9%', '9%', '8%'],
        stretchH: 'all',
        startRows: 10,
        afterChange: function (changes, source) {
          let data = this.getSourceData();
          data.forEach((v, index) => {
            v.index = index + 1;
            v.odNum = v.odNum || 1;
            v.fzNum = v.fzNum || 2;
            // v.prices = v.prices ? v.prices : 0;
            v.purificationWay = v.purificationWay? v.purificationWay : _this.defaultPurificationWay
          });
          let _that = this
          function holeChange(change) {
            data.length &&
            data.forEach((v, index) => {
              if (
                      change[0] === index &&
                      change[1] === "sequence"
              ) {
                v.sequence = v.sequence.toUpperCase();
                v.sequence = v.sequence ? v.sequence.replace(/\s/g, '') : v.sequence;
                v.dsDna = v.sequence.replace(/\*/g, '').length;
                // _that.setDataAtCell(change[0], 3, change[3].length || '')
              }

              if (
                      change[0] === index &&
                      change[1] === "checkbox"
              ) {
                v.checkbox = change[3];
              }             
              if (
                change[0] === index &&
                change[1] === "purificationWay"
              ) {
                v.purificationWay = change[3] !== '' ? change[3] : _this.defaultPurificationWay
                if( change[3]=='WLYW'){
                    v.fzNum=1
                }
              }
              //当纯化方式为WLYW的时候，分装管数永远为1(当修改分装管数时，改完就设置成1)
              // if (
              //   change[0] === index &&
              //   change[1] === "fzNum"&&
              //   v.purificationWay=='WLYW'
              // ){
              //   v.fzNum=1
              // }
            });
          }

          if (changes) {
            //复制黏贴改变
            changes.filter((v, index) => {
              holeChange(v);
            });

            data.forEach((v, index) => {
              _this.$set(_this.hotSettings.data, index, v);
            });
            this.loadData(data);
          }
          if(changes){
            //常规引物序列不支持ui添加变红样式
            let hotSettingsdata= _this.hotSettings.data;
            const validSeq = hotSettingsdata.some(({sequence, modify3, modify5, modifyMid}) => [modify3, modify5, modifyMid].every(item => !item) && /[UI]/.test(sequence))
            if(validSeq) {
              _this.$message.error('常规引物序列不支持 U 或 I')
           }
           const testHot = _this.$refs.hotTable.hotInstance;
           hotSettingsdata.forEach(({sequence, modify3, modify5, modifyMid},row)=>{
            //  if(thisColumn.sequence&&thisColumn.modify3==""&&thisColumn.modify5==""&&thisColumn.modifyMid==""){
               if([modify3, modify5, modifyMid].every(item => !item) && /[UI]/.test(sequence)){
                 const cellele = testHot.getCell(row, 3);
                 cellele.style = "color:red!important";
               }
            //  }
           })

          }
        },
        afterValidate: function (isValid, value, row, prop, source) {

          if (!isValid) {
            console.log(value)
            // if (prop === 'name') {
            //   _this.$message.error('引物名称限制输入“大小写英文字母”、“-”、“.”、“阿拉伯数字”')
            // }
            if (prop === 'sequence' && value.length <= 300) {
              _this.$message.error('引物序列必须由ATCGMRWSYKVHDBNIU*字符组成')
            }
            if (prop === 'sequence' && value.length > 300) {
              _this.$message.error('引物序列最多由300个字符组成')
            }
            if (prop === 'odNum') {
              _this.$message.error('OD/管数量范围为1-1000')
            }
            if (prop === 'fzNum') {
              _this.$message.error('分装管数量范围为1-1000')
            }
          }
          //常规引物不能输入I和U，（常规引物的判断标准是5端修饰、3端修饰、中间修饰为空）
          //复制粘贴大于十条时有bug获取不到数据,故注释此代码
          // let thisColumn=_this.hotSettings.data[row];
          // if(prop === 'sequence'&&thisColumn&&thisColumn.modify3==""&&thisColumn.modify5==""&&thisColumn.modifyMid==""){
          //    if(value.toLocaleUpperCase().includes("I")||value.toLocaleUpperCase().includes("U")){
          //       _this.$message.error('常规引物序列不支持 U 或 I');
          //    }
          // }
        },
        beforeOnCellMouseDown: function (el, val, html) {
          var tooltip = document.getElementById('tooltip')
          if (val.col === 3 && html.innerHTML.length > 30) {
            tooltip.innerHTML = html.innerHTML
            tooltip.style.display = 'block'
            var tooltipHeight = tooltip.offsetHeight
            tooltip.style.top = val.row * 42 - tooltipHeight + 50 + 'px'
          } else {
            tooltip.style.display = 'none'
          }
        },
        beforeChange: function() {
          console.info('before change', _this.hotSettings.data)
          _this.dataTemp = _this.hotSettings.data
        },
        afterOnCellCornerMouseDown: function() {
          _this.hotSettings.maxRows = _this.hotSettings.data.length
        },
        beforeSelection: function() {
          console.info('beforeSelection')
        },
        afterSelection: function(row, column, row2, column2, preventScrolling, selectionLayerLevel) {
          console.info(row, column, row2, column2, preventScrolling, selectionLayerLevel)
          _this.hotSettings.maxRows = 500
        },
        beforeSetRangeEnd: function(coords) {
          console.info(coords)
          console.info('after change', _this.hotSettings.data)
        }
      },
      dataTemp: [],
      single: {
        id: '',
        checkbox: false,
        index: 0,
        name: '',
        sequence: '',
        dsDna: '',
        // purificationWay: this.baseMethods.getLocalObj('memberInfo').businessRequirement.primerPurificationType,
        odNum: 1,
        fzNum: 2,
        modify5: '',
        modify3: '',
        modifyMid: '',
        remark: ''
      },
      unCompleteOrders: 0,
      id: this.$route.query.id
    }
  },
  watch:{
       hotSettings: {
             handler:function () {
                     setTimeout(()=>{
                       this.validUI();
                     }, 35)
             },
             deep:true
           }

  },
  created() {
    this.init()
    this.getPrimerConfig()
    this.getOrders()
    this.handleModifyList()
  },
  methods: {
    init () {
      if (!this.id) {
        this.initTable()
      } else {
        this.getDetails()
        this.getPrimerLists()
      }
    },
    initTable () {
      this.hotSettings.data = []
      for (let i = 0; i < 10; i++) {
        let item = JSON.parse(JSON.stringify(this.single))
        item.index = i + 1
        this.hotSettings.data.push(item)
      }
    },
    // 引物详情
    getDetails () {
      primerOrderDetail(this.id).then(res => {
        this.customerRemark = res.data.value.customerRemark
      })
    },
    // 包含引物列表
    getPrimerLists () {
      this.hotSettings.data = []
      primerInfo(this.id, 0, 500).then(res => {
        this.editPrimerLists = res.data.list
        res.data.list.map((item, index) => {
          item.value.index = index + 1
          item.value.checkbox = false
          this.hotSettings.data.push(item.value)
        })
        // this.hotSettings.height = 43 * this.hotSettings.data.length
      })
    },
    getPrimerConfig() {
      primerConfig('3端修饰').then(res => {
        this.decorate3 = res.data
      })
      primerConfig('5端修饰').then(res => {
        this.decorate5 = res.data
      })
      primerConfig('中间修饰').then(res => {
        this.decorateMid = res.data
      })
    },
    // 按编号生成引物名称
    createName () {
      const { tableData } = this
      if (this.baseMethods.isEmpty(tableData[0].name)) {
        this.$message.error('第一行数据不能为空')
        return
      }
      let name = tableData[0].name
      if (name.substr(-1, 1) === '1') {
        name = name.substr(0, name.length - 1)
      }
      this.tableData.map((item, index) => {
        if (!item.name || index === 0) {
          this.$set(this.tableData[index], 'name', `${name}${index + 1}`)
        }
      })
    },
    // 新增一行
    addRow () {
      let temp = { ...this.single }
      let len = this.hotSettings.data.length
      temp.index = len + 1
      this.hotSettings.data.push(temp)
      this.setTableHeight(temp.index)
    },
    setTableHeight (rows) {
      if (rows === 0) {
        this.hotSettings.height = 0
      } else {
        this.hotSettings.height = 430
      }
    },
    // 应用
    handleUsePrimers() {
      let len = this.hotSettings.data.length
      const primerNum = this.primerNum
      // if (!len) return this.$message.warning('请创建引物信息后应用')

      if (primerNum > 500)
        return this.$message.warning('应用失败，应用数范围为0-500')
      if (this.baseMethods.isEmpty(primerNum))
        return this.$message.warning('应用行数不能为空')
      if (primerNum < len) {
        if (primerNum <= 0) {
          this.$message.warning('应用数据必须大于0')
        } else {
          this.$confirm('多于行数将删除，是否确认当前操作?').then(
            (res) => {
              this.hotSettings.data = this.hotSettings.data.slice(
                0,
                primerNum
              )
              this.setTableHeight(primerNum)
            }
          )
        }
      } else if (primerNum > len) {
        let temp = { ...this.single }
        for (let index = len; index < primerNum; index++) {
          temp = JSON.parse(JSON.stringify(temp))
          temp.index = index + 1
          this.hotSettings.data.push(temp)
        }
        this.setTableHeight(primerNum)
        return this.$message.success('引物条数应用成功')
      }
    },
    nameClick() {
      if (!this.hotSettings.data.length) return false;
      let name = this.hotSettings.data[0].name
      if (this.baseMethods.isEmpty(name)) {
        this.$message.error('请先添加第一行数据')
        return
      }
      if (name) {
        this.hotSettings.data.forEach((v) => {
          v.name = name + v.index;
        });
      }

    },
    handleSimpleClick(type) {
      if (!this.hotSettings.data.length) return false;
      let typeName = this.hotSettings.data[0][type];
      if (typeName === '') {
        this.$message.error('请先添加第一行数据')
        return
      }
      this.hotSettings.data.forEach((v) => {
        v[type] = typeName;
        if (type === "sequence") {
          v.sequence = v[type] ? v[type].replace(/\s/g, '') : v[type];
          v.dsDna = v[type].replace(/\*/g, '').length;
        }
      })
      const that = this
      setTimeout(function() {
        that.$refs.hotTable.hotInstance.updateSettings({
          data: that.hotSettings.data
        })
        that.validUI();
      }, 35)

    },
    validUI(){
        //常规引物序列不支持ui添加变红样式
        let hotSettingsdata= this.hotSettings.data;
        const testHot = this.$refs.hotTable.hotInstance;
        hotSettingsdata.forEach(({sequence, modify3, modify5, modifyMid},row)=>{
          // if(thisColumn.sequence&&thisColumn.modify3==""&&thisColumn.modify5==""&&thisColumn.modifyMid==""){
            if([modify3, modify5, modifyMid].every(item => !item) && /[UI]/.test(sequence)){
              const cellele = testHot.getCell(row, 3);
              cellele.style = "color:red!important";
            }
          // }
        })

    },
    deleteSelect () {
      let bool = this.hotSettings.data.some((v) => v.checkbox);
      if (!bool) {
        return this.$message.warning("请选择要删除的数据");
      }
      this.$confirm("是否确认删除当前数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteMethods()
      })
    },
    deleteMethods() {
      this.hotSettings.data = this.hotSettings.data.filter(
        (v) => !v.checkbox
      );
      if (!this.hotSettings.data.length) {
        this.setTableHeight(0)
        return false
      }

      this.$message.success("删除成功");
      this.hotSettings.data.length &&
      this.hotSettings.data.forEach((v, index) => {
        v.index = index + 1;
      });
      this.setTableHeight(this.hotSettings.data.length)
    },
    checkboxOnclick(evt) {
      this.hotSettings.data.forEach(
        (v) => (v.checkbox = evt.target.checked)
      )
    },
    //获取导入模板的数据
    getResponseData(data) {
      this.$message.success("数据导入成功");
      this.hotSettings.data = [];
      data.forEach((v, index) => {
        v.sequence = v.sequence ? v.sequence.replace(/\s/g, '') : v.sequence;
        v.dsDna = v.sequence.replace(/\*/g, '').length || 0;
        v.synthesisNum = clacSynthesisNum(v);
        v.molecularNum = clacMolecularNum(v);
        this.$set(this.hotSettings.data, index, v);
      });
    },
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v)
      })
    },
    // 提交
    bindConfirm () {
      let primerInfo = {
        customerRemark: this.customerRemark,
        primer: []
      }
      const keys = ['name', 'sequence', 'purificationWay', 'odNum', 'fzNum']
      const defaultKeys = ['odNum', 'fzNum', 'purificationWay']
      let keys2 = []
      let defaultKeys2 = []
      let must = true
      this.hotSettings.data.map(item => {
        item.synthesisNum = 0
        item.showOrderFlag = false
        if (must) {
          keys2 = Object.keys(item).filter((val) => { return keys.includes(val) && item[val] !== '' && item[val] })
          defaultKeys2 = defaultKeys.filter(value => { return keys2.includes(value) })
          if (keys2.length > defaultKeys2.length && keys2.length !== keys.length) {
            must = false
          }
        }
        if (keys2.length === keys.length) {
          primerInfo.primer.push(item)
        }
      })
      if (!must) {
        this.$message.error('请补充所有必填项')
        return
      }
      if (primerInfo.primer.length === 0) {
        this.$message.error('请至少添加一行数据')
        return
      }
      // 过滤出引物序列中包含字符“U”或”I”且“5端修饰”、“3端修饰”、“中间修饰”这三种修饰内容均为空的数据
      //some遇到一项符合条件的就返回真，并不在往下执行
      let booleanUI=this.hotSettings.data.some(item=>{
        // return item.modify3&&item.modify5==""&&item.modifyMid==""&& (item.sequence.toLocaleUpperCase().includes("U")||item.sequence.toLocaleUpperCase().includes("I"))
        return [item.modify3,item. modify5, item.modifyMid].every(field => !field) && /[UI]/.test(item.sequence)
      })
      if(booleanUI){
        this.$message.error('提交失败，存在包含 U 或 I 的常规引物');
        return false;
      }


      let delIds = []
      if (primerInfo.primer.length < this.editPrimerLists.length) {
        let ids = []
        let newIds = []
        this.editPrimerLists.map(item => {
          ids.push(item.value.id)
        })
        primerInfo.primer.map(item => {
          newIds.push(item.id)
        })
        delIds = this.getArrDifference(ids, newIds)
      }
      const hotRef = this.$refs.hotTable.hotInstance
      let amount = 0
      hotRef.validateCells(async (valid) => {
        if (valid) {
          this.submitLoading = true
          const memberInfo = this.baseMethods.getLocalObj('memberInfo', true)
          const courseInfo = this.baseMethods.getLocalObj('courseInfo', true)
          try {
            const numFruits = await primerPrice(primerInfo.primer)
            numFruits.data.map((item, index) => {
              this.$set(primerInfo.primer[index], 'priceY', item.priceY)
            })

            if (primerInfo.primer.filter(item => !item.priceY).length > 0) {
              amount = null
            } else {
              primerInfo.primer.map(item => {
                amount += item.priceY
              })
            }
            let sumbitData = {
              primerSynthesesSet: primerInfo.primer,
              submitFlag: false,
              discountCoefficient: 1,
              // baseId: courseInfo.base.id,
              showOrderFlag: false,
              customerRemark: this.customerRemark,
              customerId: memberInfo.id,
              clientGrade: memberInfo.level,
              customerEmail: memberInfo.email,
              // researchTeamId: memberInfo.researchGroup.id,
              // serviceSalesId: memberInfo.serveSeller.id,
              deletePrimerSynthesesIdSet: delIds,
              amount: Number((amount * 100).toFixed(2)),
              settlementAmount: Number((amount * 100).toFixed(2))
            }
            if (this.id) {
              primerOrderEidt(this.id, sumbitData).then(res => {
                if (!this.baseMethods.isEmpty(res)) {
                  this.$message.success('修改成功')
                  this.$router.push(`/tec/primer_confirm?id=${this.id}`)
                } else {
                  this.$message.error('请求超时，请重试')
                }
              }).catch(() => {
                this.$message.error('请求超时，请重试')
              }).finally(() => {
                this.submitLoading = false
              })
            } else {
              primerOrder(sumbitData).then((res) => {
                this.submitLoading = false
                if (!this.baseMethods.isEmpty(res)) {
                  this.$message.success('提交成功')
                  this.$router.push(`/tec/primer_confirm?id=${res.data.id}`)
                } else {
                  this.$message.error('请求超时，请重试')
                }
              }).catch(() => {
                this.$message.error('请求超时，请重试')
              }).finally(() => {
                this.submitLoading = false
              })
            }
          } catch (e) {
            this.$message.error('请求超时，请重试')
          }finally {
            this.submitLoading = false
          }
        } else {
          // this.$message.error('请检查数据格式')
        }
      })
    },
    // 模板上传
    uploadFiles (e) {
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      uploadPrimer(formData).then(res => {
        this.uploading = false
        res.data.map((item, index) => {
          item.index = index + 1
          item.sequence = item.sequence.toUpperCase()
          item.sequence = item.sequence ? item.sequence.replace(/\s/g, '') : item.sequence;
          item.dsDna = item.sequence.replace(/\*/g, '').length
          if (!this.purificationWays.includes(item.purificationWay)) {
            item.purificationWay = ''
          }
          if (!this.decorate5.includes(item.modify5)) {
            item.modify5 = ''
          }
          if (!this.decorate3.includes(item.modify3)) {
            item.modify3 = ''
          }
          if (!this.decorateMid.includes(item.modifyMid)) {
            item.modifyMid = ''
          }
          this.$set(this.hotSettings.data, index, item);
          // this.$set(this.tableData[index], 'errorSequence', !this.checkSequence(item.sequence))
        })
      })
    },
    // 清空表格
    clearTable () {
      this.$confirm('确定清除表格所有内容？', '提示', {
      }).then(() => {
        this.initTable()
      })
    },
    // 最大输入三位
    inputPrimerNum (value) {
      if (value.length >= 3) {
        this.primerNum = value.substr(0, 3)
      }
    },
    // 未完成订单
    getOrders () {
      const searchIds = this.baseMethods.getSearchId()
      primer(0, 100, '', '', '', 'WAIT', searchIds[0], searchIds[1]).then(res => {
        this.unCompleteOrders = res.data.totalCount
      })
    },
    // 跳转到未处理订单
    toOrders () {
      this.$router.push('/user/primer?status=WAIT')
    },
    //获取板流转或者条流转的字典列表
		async handleModifyList() {
			await getSystemDictByUnitType({ modifiedType: '' }).then(({data}) => {
				const plateData = data
        this.hotSettings.columns.forEach((e) => {
          switch (e.data) {
            case "modify3":
              plateData[0].forEach(v => {
                e.source.push(v.modify3)
              })
              break;
            case "modify5":
              plateData[1].forEach(v => {
                e.source.push(v.modify5)
              })
              break;
            case "modifyMid":
              plateData[2].forEach(v => {
                e.source.push(v.modifyMid)
              })
              break;
          }
          e.source = [...new Set(e.source)]
        });
			});
		},
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/order_primer.vue